
import { useEffect, useRef, useState, version } from 'react';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Input from '../../../../components/Inputs/Input';
import { Sorting } from '../../../../components/Lists/Sorting';
import { Tag } from '../../../../components/Tags/Tag';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import './VendorsCost.css';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import { Radios } from '../../../../components/RadioGroup/Radios';
import { deleteRangeReq, getPartConditions, getSpecificCost } from '../../services/SupplyChainService';
import { HTTP_RESPONSE_CODES, LABELS } from '../../../../globals/globals';
import CustomTabs from '../../../../components/Tabs/Tabs';
import { Popover, Skeleton, Tab, Tabs } from '@mui/material';
import { fetchCurrencies, fetchVendorsForCost, selectPartVendors, selectSelectedVendor, fetchConditions, selectVendor, addCost, addNewVendor, selectEditingStatus, selectUnsaved, selectVendorParams, updateVendorParams } from '../../../../redux/features/configuration/parts/vendorCostSlice';
import { useDispatch, useSelector } from 'react-redux';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import { ConditionsMenu } from './ConditionsMenu';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import DeletePartDialog from './DeletePartDialog';
import dayjs from 'dayjs';
import { VendorContent } from './VendorContent';
import { SearchBar } from '../../../../components/SearchBar/SearchBar';

const mockHisotry = [
    { id: 1, initialDate: '2025-03-16', finalDate: '2025-06-28', unitCost: '158.21', active: true },
    { id: 2, initialDate: '2025-08-05', finalDate: '2025-09-14', unitCost: '277.49' },
    { id: 3, initialDate: '2025-12-02', finalDate: '2025-12-19', unitCost: '123.65' },
    { id: 4, initialDate: '2025-05-12', finalDate: '2025-08-31', unitCost: '196.38' },
    { id: 5, initialDate: '2025-01-07', finalDate: '2025-04-23', unitCost: '134.80' },
    // { id: 6, initialDate: '2025-04-20', finalDate: '2025-05-15', unitCost: '166.99' },
    // { id: 7, initialDate: '2025-09-09', finalDate: '2025-11-22', unitCost: '112.04' },
    // { id: 8, initialDate: '2025-02-25', finalDate: '2025-05-10', unitCost: '188.17' },
    // { id: 9, initialDate: '2025-06-14', finalDate: '2025-07-25', unitCost: '141.56' },
    // { id: 10, initialDate: '2025-11-30', finalDate: '2025-12-20', unitCost: '173.32' },
];


export const VendorsCost = ({ part, onClose, costType }) => {

    const dispatch = useDispatch();
    const vendors = useSelector(selectPartVendors);
    const selectedVendor = useSelector(selectSelectedVendor);
    const editingStatus = useSelector(selectEditingStatus);
    const unsaved = useSelector(selectUnsaved);
    const vendorParams = useSelector(selectVendorParams);


    useEffect(() => {
        if (Boolean(vendorParams.orderBy)) {
            dispatch(fetchConditions({ costType })).then(action => {

                dispatch(fetchVendorsForCost({ partId: part.id, key: costType, vendorParams }));
                dispatch(fetchCurrencies({ a: 0 }));
            });
        }
        // dispatch(updateCostType(costType));
        // dispatch(fetchConditionCosts);
    }, [vendorParams]);  

    const addVendor = () => {
        dispatch(addNewVendor());
    }

    const selectNewVendor = (v) => {
        dispatch(selectVendor(v))
    }

    return (
        <div className='vendors-cost-cpomponent'>
            <div className='header'>
                <div className='title'>
                    <b>{costType === "C" ? "Vendor Cost" : "Vendor Repair Capability"}</b>
                    <div>
                        <span>PN</span>
                        <b>{part.partNumber}</b>
                    </div>
                    <div>
                        <span>PN Description</span>
                        <b>{part.description}</b>
                    </div>
                    <div>
                        <span>Category</span>
                        <b>{part.categoryName}</b>
                    </div>
                    <div>
                        <span>Sub Category</span>
                        <b>{part.subCategoryName}</b>
                    </div>
                    <div>
                        <span>ATA</span>
                        <b>{"00-00-00"}</b>
                    </div>
                </div>
                <button className='outlined icon small-size' onClick={onClose}>
                    <i className='icon-cross'></i>
                </button>
            </div>
            <hr></hr>
            <div className='vendors-content'>

                <div className='left-container'>
                    <div className='title'>
                        <b>Vendors</b>
                        <SearchBar onChange={(debValue) => dispatch(updateVendorParams({name:"search", value: debValue}))} />
                        {/* <Input label="" placeholder="Search" /> */}
                        <button className='outlined icon small-size' onClick={addVendor}>
                            <i className='icon-add-new'></i>
                        </button>
                    </div>
                    <div className='list' style={{ zIndex: 20 }}>
                        <Sorting onOrderChange={(newOrder) => dispatch(updateVendorParams({name: "orderBy", value: newOrder}))} displayButton={false} properties={{ vendorName: "Vendor", identificationNumber: "Id Vendor" }} />
                        {
                            vendors.map((v, idx) =>
                                <>
                                    <div onClick={() => selectNewVendor(v)} className={`vendor-item ${v.tempId === selectedVendor?.tempId ? 'active' : ''}`} vendor key={idx}>
                                        {editingStatus[v.tempId] && <div className='ribbons-container'>
                                            <div className='ribbon small'>{LABELS.EDITION_MODE}</div>
                                        </div>}
                                        {/* FIXME: favorite in the backend service */}

                                        <span>
                                            {v.isPreferredVendor === 'true' && <i className='icon-favorite'></i>}
                                            {v.vendorName || "--"}</span>
                                        <span>{v.identificationNumber ?? "--"}</span>
                                    </div>

                                </>
                            )
                        }
                    </div>
                </div>
                {selectedVendor && <VendorContent part={part} vendorTempId={selectedVendor.tempId} />}

                {/* {selectedVendor && <div className='right-container'>
                    <div className='right-header'>
                        <b>Vendor</b>
                        <Dropdowns disabled={!(editingStatus[selectedVendor.tempId])} preSelectValue={preselectVendor} hideLabel optionLabel="name" onOptionSelect={(vendor) => updateVendorVendor(vendor, selectedVendor)} data={vendorDrpdwn.config} parameters={companyParameter} />
                        <span>Currency</span>
                        <Dropdowns disabled={!(editingStatus[selectedVendor.tempId])} onOptionSelect={(currency) => updateVendorCurrency(currency, selectedVendor)} preSelectValue={preSelectCurrency} hideLabel data={currencyDrpdwn.config} />

                        <div className='actions'>
                            {(editingStatus[selectedVendor.tempId]) ?
                                <MultioptionButton buttons={saveButtons} buttonCallbacks={{
                                    'save': () => saveClick(true),
                                    'save-continue': () => saveClick(false),
                                    'cancel': () => cancelEdition()
                                }}></MultioptionButton>
                                : <i onClick={() => startEdition()} className='icon-edit'></i>}
                        </div>
                    </div>
                    <div className='tabs'>
                        <VendorTabs currency={currencies[currencyByVendor[selectedVendor?.tempId]]} costType={costType} vendor={selectedVendor} part={part} />
                    </div>
                </div>} */}
            </div>
        </div>
    );
}

// const VendorTabs = ({ part, vendor, costType, currency }) => {
//     const [tab, selectTab] = useState(null);
//     const [partConditions, setPartConditions] = useState([]);
//     const [conditionTabs, setConditionTabs] = useState([]);

//     const [tabSelection, setTabSelection] = useState(new Set([]));
//     const tatVendorInfo = useSelector(selectTATInfo);
//     const preSelectedTab = useSelector((state) => selectTabPreSelect(state, vendor.tempId))
//     const dispatch = useDispatch();
//     const { successMsg, warningMsg, infoMsg } = useSnackBar();

//     useEffect(() => {
//         getPartConditions(costType).then(response => {
//             if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
//                 setPartConditions(response.data.load);
//                 selectTab(response.data.load?.[0]);
//                 // setTabSelection(response.data.load.reduce((acc, curr) => ({ ...acc, [curr.id]: false }), {}));
//             }
//         })
//     }, []);

//     useEffect(() => {
//         let foundTab = partConditions.find(p => p.id === preSelectedTab);
//         if (foundTab) {
//             selectTab(foundTab);
//             document.getElementById(`tab/${vendor.tempId}/${foundTab.id}`)?.scrollIntoView({ behavior: "smooth", })
//         }
//     }, [preSelectedTab])

//     useEffect(() => {
//         // if (vendor.isNew) {
//         // selectTab(null);
//         let tabId = Object.keys(tatVendorInfo?.[vendor.tempId] ?? {})[0] ?? null;
//         console.warn('tabid', tabId);
//         let tab = partConditions.find(c => c.id === parseInt(tabId));
//         console.warn('foundTab', tab);
//         selectTab(tab ?? null);
//         // }
//     },
//         [vendor]);

//     useEffect(() => {
//         dispatch(updateSelectedTab(tab));

//     }, [tab])

//     useEffect(() => {
//         if (tatVendorInfo) setTabSelection(new Set(Object.keys(tatVendorInfo?.[vendor.tempId] ?? {}).map(k => parseInt(k))))
//     }, [tatVendorInfo?.[vendor.tempId]])

//     useEffect(() => {
//         dispatch(fetchTATInfo({ vendorId: vendor.vendorId, vendorTempId: vendor.tempId, partConditionIds: partConditions.map(c => c.id), partId: part.id, costType })).then(action => {
//             if (action.payload) {
//                 let { vendorTempId, partConditionIds, currencyId, vendorId, load } = action.payload;
//                 let tatItems = Object.entries(load);
//                 tatItems.forEach(([conditionId, tatItem]) => {
//                     dispatch(fetchConditionCosts({ tatId: tatItem.id, vendorTempId: vendor.tempId, conditionId: parseInt(conditionId) }));
//                 })

//             }
//         })
//         // selectTab(null);
//     }, [vendor, partConditions]);

//     const currentTat = useRef(null);

//     useEffect(() => {
//         // console.warn('change vendor / tab', tab, vendor, tatVendorInfo?.[vendor.tempId]);
//         // if (vendor && tab && typeof(tatVendorInfo?.[vendor.tempId]?.[tab.id].id) === 'number') {
//         //     // dispatch(fetchConditionCosts({ partId: part.id, vendorId: vendor.vendorId, tatId: tatVendorInfo[vendor.tempId]?.[tab.id]?.id, vendorTempId: vendor.tempId, conditionId: tab.id }))
//         // }
//     }, [tab, vendor]);


//     // Popover
//     const [anchorEl, setAnchorEl] = useState(null);

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };

//     const open = Boolean(anchorEl);
//     const id = open ? 'simple-popover' : undefined;

//     const applyClick = (idObj) => {
//         //FIXME: send delete request for the conditions to be removed.
//         dispatch(applyConditionSelection({ deleteConditions: Array.from(idObj.deleteConditions), newConditions: Array.from(idObj.newConditions), vendorTempId: vendor.tempId, costType }))
//     }
//     const tabsCount = Object.keys(tatVendorInfo?.[vendor.tempId] ?? {}).length;
//     const [disabledNav, setDisabledNav] = useState({ left: true, right: false });

//     const tabsContainerRef = useRef(null);


// const handleScroll = (e) => {
//     let maxLeft = e.target.scrollWidth - e.target.clientWidth;
//     setDisabledNav({
//         left: e.target.scrollLeft < 1,
//         right: e.target.scrollLeft >= maxLeft - 3
//     });
// }

//     const navigate = (direction) => {
//         scrollToNextElement(tabsContainerRef.current, direction);
//     }

//     const tatLoading = useSelector(selectTatLoading);

//     const deleteVendorCondition = (vendorTempId, conditionId) => {
//         dispatch(deleteTATInfo({ tatInfoId: tatVendorInfo?.[vendorTempId]?.[conditionId]?.id, conditionId, vendorTempId })).then(action => {
//             let response = action.payload;
//             if (response.responseCode === HTTP_RESPONSE_CODES.DELETED) {
//                 successMsg("Part Condition Removed");
//             } else {
//                 warningMsg(response.message);
//             }
//         })

//     }

//     const handleDeleteTab = (conditionId) => {
//         dispatch(discardCondition({ conditionId, vendorTempId: vendor.tempId }));
//         let availableCond = partConditions.filter(c => (c.id in (tatVendorInfo?.[vendor.tempId] ?? {})) && (c.id !== conditionId));
//         console.warn('*available conditions', availableCond);
//         if (availableCond.length > 0) {
//             console.warn('*if');

//             let id = availableCond[availableCond.length - 1].id;
//             console.warn('*available', id);
//             let element = document.getElementById(`tab/${vendor.tempId}/${id}`);
//             console.warn('*element', element);
//             // console.warn('*if true', availableCond[availableCond.length - 1]);
//             // selectTab({name: "Used", id: 2});
//         } else {
//             selectTab(null);
//         }
//         infoMsg("Condition Discarded");
//     }

//     useEffect(() => {
//         console.warn('*tab changed', tab);
//     }, [tab])

//     return (
//         <div className='vendor-tabs-component'>
//             {/* {JSON.stringify(tabSelection)} */}
//             {/* {JSON.stringify(tatVendorInfo?.[vendor.tempId])}  */}
// <div className='tabs'>

//     {(tabsCount < 1) && <b className='button-label'>{costType === "C" ? "Add New Condition" : "Add Repair Type"}</b>}

//     <button className='filled icon mid-size' onClick={handleClick}>
//         <i className='icon-add-new small-icon'></i>
//     </button>

//     {/* <i>
//         {JSON.stringify(currency)}
//     </i> */}
//     {/* {JSON.stringify(tab)} */}


//     <Popover
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//             vertical: 'top',
//             horizontal: 'right',
//         }}
//         transformOrigin={{
//             vertical: 'top',
//             horizontal: 'left',
//         }}
//     >
//         <ConditionsMenu addClick={applyClick} preSelect={tabSelection} conditions={partConditions} handleClose={handleClose} />
//     </Popover>

//     {(tabsCount > 3) && <button onClick={() => navigate("l")} className='filled icon mid-size leftbutton' disabled={disabledNav.left}>
//         <i className='icon-arrow-down chevron-left'></i>
//     </button>}


//     <div className='tabs-container' onScroll={handleScroll} ref={tabsContainerRef}>
//         {/* {partConditions.filter(c => c).map(c => */}
//         {partConditions.filter(c => c.id in (tatVendorInfo?.[vendor.tempId] ?? {})).map(c =>
//             <button id={`tab/${vendor.tempId}/${c.id}`} tabIndex={0} onClick={() => selectTab(c)} className={`transparent tab ${tab?.id === c.id ? 'active' : ''}`} key={c.name}>
//                 <span>

//                     {c.name}
//                 </span>

//                 {/* FIXME: discard new (unsaved) conditions */}
//                 <div className='delete-btn-container'>
//                     {
//                         (typeof (tatVendorInfo?.[vendor.tempId]?.[c.id].id) === "number") ?

//                             <DialogTrigger
//                                 dialogContent={{
//                                     component: DeletePartDialog,
//                                     props: {
//                                         item: {},
//                                         message: `Are you sure you want to delete the ${costType === "C" ? "condition" : "repair type"} "${c.name}" for this vendor?`,
//                                         onDelete: () => deleteVendorCondition(vendor.tempId, c.id)
//                                     }
//                                 }}
//                             >
//                                 <i className='icon-delete-new'></i>
//                             </DialogTrigger> :
//                             <i className='icon-delete-new' onClick={() => handleDeleteTab(c.id)}></i>

//                     }
//                 </div>


//             </button>
//         )}
//     </div>

//     {(tabsCount > 3) && <button onClick={() => navigate("r")} className='filled icon mid-size' disabled={disabledNav.right}>
//         <i className='icon-arrow-down chevron-right'></i>
//     </button>}

// </div>

//             <div className='tab-content'>
//                 {tatLoading ? <>

//                     <Skeleton height="var(--item-min-height)" />
//                     <Skeleton height="var(--item-min-height)" />
//                     <Skeleton height="var(--item-min-height)" />
//                     <Skeleton height="var(--item-min-height)" />
//                 </> : <>

//                     {(tabsCount < 1) && !tatLoading && <div className='placeholder-container'>
//                         <b>Add {costType === "C" ? "Conditions" : "Repair Types"} before proceeding.</b>
//                         <span>
//                             To continue, you need to add at least one {costType === "C" ? "condition" : "repair type"}
//                             <br></br>
//                             using the {costType === "C" ? "Add New Condition" : "Add Repair Type"} (+) button
//                         </span>
//                     </div>}
//                     {(tabsCount >= 1) && tab && vendor && <VendorTabContent currency={currency} condition={tab} vendorId={vendor.vendorId} partId={part.id} vendorTempId={vendor.tempId} />}
//                 </>}
//             </div>
//         </div >
//     )
// }

// const saveButtons = [
//     { label: 'Save and Finish', icon: "icon-save", id: 'save' },
//     { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
//     { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
// ];

// const VendorTabContent = ({ condition, partId, vendorId, vendorTempId, currency }) => {

//     const conditionCosts = useSelector(selectVendorConditionCosts);
//     const dispatch = useDispatch();
//     const TATInfo = useSelector((state) => selectTATInfoCondition(state, vendorTempId, condition.id));
//     const isEditing = useSelector((state) => selectEditStatus(state, vendorTempId));
//     const { successMsg, warningMsg } = useSnackBar();
//     const vendorCurrencies = useSelector(selectVendorCurrency);
//     const tempVendors = useSelector(selectTempVendor);
//     // useEffect(() => {
//     //     dispatch(fetchTATInfo({ conditionId: condition.id, partId, vendorId, vendorTempId }));
//     // }, [condition, vendorTempId]);

//     const handleFormChange = (e) => {
//         console.warn('event', e);
//         dispatch(updateTAT({ ...e.target, vendorId, vendorTempId, conditionId: condition.id }))
//     }

//     // const startEditing = () => {
//     //     dispatch(updateEditStatus({ status: true, vendorTempId, conditionId: condition.id, vendorId }));
//     // }

//     // const saveClick = (closeEdition) => {
//     //     console.warn('drpdwn values', tempVendors[vendorTempId], vendorCurrencies)
//     //     dispatch(saveTATInfo({ tat: { ...TATInfo, vendorId: tempVendors[vendorTempId], currencyId: vendorCurrencies[vendorTempId], partConditionId: condition.id, companyId: localStorage.getItem('u_company_id'), partId }, closeEdition, vendorTempId })).then(action => {
//     //         //    console.warn('response', response);
//     //         let response = action.payload;
//     //         if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(response.data.responseCode)) {
//     //             successMsg("Vendor information Saved");
//     //         } else {
//     //             warningMsg(response.data.message);
//     //         }
//     //     })
//     // }

//     // const cancelEdition = () => {
//     //     dispatch(updateEditStatus({ status: false, conditionId: condition.id, vendorId }));
//     // }

//     const createNewList = () => {
//         dispatch(addConditionCost({ vendorTempId, conditionId: condition.id }));
//     }


//     return (
//         <div className='vendor-tab-content-component'>
//             <div className='header'>
//                 <b>Vendor Information</b>
//             </div>
//             <div className='tat-container'>
//                 {/* {JSON.stringify(TATInfo?? false)} */}
//                 <div className='tat-item'>
//                     <span>Estimated Turn Around Time (TAT)</span>
//                     <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.tat_estimated ?? ""} label="" name="tat_estimated" isNumeric onChange={handleFormChange} />
//                     <span>Days</span>
//                 </div>
//                 <div className='tat-item'>
//                     <span>Average Turn Around Time</span>
//                     <Input disableAutocomplete disabled={true} value={TATInfo?.tat_average ?? ""} name="tat_average" onChange={handleFormChange} label="" isNumeric />
//                     <span>Days</span>
//                 </div>
//             </div>
//             <div className='warranty'>
//                 <div className='warranty-item'>
//                     <span style={{ color: 'transparent' }}>
//                         .
//                     </span>

//                     <b>Warranty</b>
//                 </div>
//                 <div className='warranty-item'>
//                     <span>
//                         Hours
//                     </span>
//                     <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_hours ?? ""} name="warranty_hours" onChange={handleFormChange} label="" isNumeric />
//                 </div>
//                 <div className='warranty-item'>
//                     <span>
//                         Cycles
//                     </span>
//                     <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_cycles ?? ""} name="warranty_cycles" onChange={handleFormChange} label="" isNumeric />
//                 </div>
//                 <div className='warranty-item'>
//                     <span>
//                         Aircraft Days
//                     </span>
//                     <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_aircraft_days ?? ""} name="warranty_aircraft_days" onChange={handleFormChange} label="" isNumeric />
//                 </div>
//                 <div className='warranty-item'>
//                     <span>
//                         Calendar Days
//                     </span>
//                     <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_calendar_days ?? ""} name="warranty_calendar_days" onChange={handleFormChange} label="" isNumeric />
//                 </div>
//             </div>
//             <div className='cost-container'>
//                 <div className='header'>
//                     {/* FIXME: use actual correct icon */}
//                     <div>
//                         <i className='icon-report-checked'></i>
//                         <b>Cost per Quantity Range and Cost History</b>
//                     </div>
//                     {isEditing && <button onClick={createNewList} className='filled small-size'>
//                         New List
//                     </button>}
//                 </div>
//                 <div className='history'>
//                     <div className='history-header'>
//                         <b>Initial Date</b>
//                         <b>Final Date</b>
//                         <b>Unit Cost</b>
//                         <b></b>
//                     </div>
//                     {
//                         (!(conditionCosts?.[vendorTempId]?.[condition?.id ?? 0]?.length > 0)) && <div className='placeholder-component'><i>No costs configured yet</i></div>
//                     }
//                     {condition && conditionCosts && <div className='history-list'>


//                         {/* {JSON.stringify(conditionCosts?.[vendorTempId]?.[condition.id].map(i =>({version:i.version, id: i.id, iDate: i.initialDate})))} */}
//                         {conditionCosts[vendorTempId]?.[condition?.id]?.map((i, idx) => <HistoryItem currency={currency} conditionId={condition.id} vendorTempId={vendorTempId} partVendorId={TATInfo?.id} key={i.id} item={i} idx={idx} />)

//                         }
//                     </div>}
//                 </div>
//             </div>
//         </div>
//     )

// }


const mockRanges = [
    { id: 1, range: '10-50', unitCost: 23.75 },
    { id: 2, range: '15-45', unitCost: 31.22 },
    { id: 3, range: '5-25', unitCost: 19.68 },
    { id: 4, range: '20-60', unitCost: 42.99 },
    { id: 5, range: '30-90', unitCost: 75.50 },
    { id: 6, range: '12-40', unitCost: 28.33 }]

const defaultRangeItem = {
    id: null,
    range: "",
    unitCost: null,
    version: 0,
}
// const HistoryItem = ({ item, id, idx, partVendorId, vendorTempId, conditionId, currency }) => {

//     // const [editing, setEditing] = useState(false);
//     const editing = useSelector(state => selectEditStatus(state, vendorTempId))
//     const [ranges, setRanges] = useState([{ ...defaultRangeItem }]);
//     const [isRangeBased, setIsRangeBased] = useState(true);
//     const [modifiedItem, setModifiedItem] = useState({ ...item });
//     // const modifiedItem = useSelector()
//     const { successMsg, warningMsg } = useSnackBar();
//     const dispatch = useDispatch();

//     const startEditing = () => {
//         // setEditing(true);
//     }

//     // useEffect(()=>{
//     //     // setModifiedItem({...item});
//     // },[item])

//     useEffect(() => {
//         dispatch(updateCost({ vendorTempId, conditionId, idx, costItem: { ...modifiedItem, version: item.version } }));
//     }, [modifiedItem]);

//     useEffect(() => {
//         setModifiedItem(prev => ({ ...prev, unitCosts: ranges.map(r => ({ ...r, companyId: parseInt(localStorage.getItem('u_company_id')) })) }));
//     }, [ranges])

//     const [openStatus, setOpenStatus] = useState(false);

//     useEffect(() => {
//         setIsRangeBased(modifiedItem.costType === "R");
//     }, [modifiedItem])

//     const onChange = (e) => {
//         let { name, value } = e;
//         setModifiedItem(prev => ({ ...prev, [name]: value }))
//     }

//     const saveClick = (closeEdition) => {
//         // saveCosts({ id: modifiedItem.id, version: modifiedItem.version ?? 0, unitCosts: ranges, partVendorId, initialDate: modifiedItem.initialDate, finalDate: modifiedItem.finalDate, costType: modifiedItem.costType }).then(response => {
//         //     if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(response.data.responseCode)) {
//         //         successMsg("Vendor Costs Saved");
//         //         setModifiedItem(response.data.load);
//         //         setRanges(response.data.load.unitCosts);
//         //         if (closeEdition) {
//         //             // setEditing(false);

//         //         }
//         //     } else {
//         //         warningMsg(response.data.message);
//         //     }
//         // })
//     }

//     const cancelEdition = () => {
//         // setEditing(false);
//     }

//     useEffect(() => {
//         if (typeof (item.id) === 'number') {
//             getSpecificCost(item.id).then(response => {
//                 if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
//                     console.warn('response specific cost', response.data.load);
//                     setRanges(response.data.load.unitCosts);
//                 }
//             })
//         }
//     }, [openStatus]);

//     const updateRange = (idx, e) => {
//         let { name, value } = e;
//         setRanges(prev => {
//             let copy = [...prev];
//             copy[idx] = { ...copy[idx], [name]: name === 'unitCost' ? (isNaN(parseInt(value)) ? "" : parseInt(value)) : value }
//             return copy
//         });
//         if (idx === 0 && name === 'unitCost') {
//             setModifiedItem(prev => ({ ...prev, "minUnitCost": value }));
//         }
//     }

//     const newRange = () => {
//         setRanges(prev => [...prev, { ...defaultRangeItem }]);
//     }

//     const handleKeyDown = (event) => {
//         console.warn(event);
//         if (isRangeBased) {
//             if (event.ctrlKey && (event.key === "a")) {
//                 event.stopPropagation();
//                 newRange();
//             }
//         }
//     }

//     const deleteRange = (rId) => {
//         deleteRangeReq(rId).then(response => {
//             if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {

//                 setRanges(prev => prev.filter(r => !(r.id === rId)));
//                 successMsg("Range rermoved");
//             }
//         })
//     }

//     const discardRange = (idx) => {
//         setRanges(prev => prev.filter((i, j) => !(j === idx)))
//         infoMsg("Range discarded");

//     }

//     return (
//         <>
//             <Expandable2 onOpenChange={(e) => setOpenStatus(e)} summary={
//                 <div className={`history-item-component ${openStatus ? 'active' : ''}`}>
//                     <span>{modifiedItem.initialDate ?? "--"}</span>
//                     <span>{modifiedItem.finalDate ?? "--"}</span>

//                     <span>$ {modifiedItem.minUnitCost ?? "--"} {currency?.prefix ?? ""}</span>
//                     <div className='actions'>
//                         {(item.active || item.isNew) && <>{item.active && <Tag type="info" tag={
//                             <>
//                                 <span>Status</span> <b>Active</b>
//                             </>
//                         } />}
//                             {/*
//                                 editing ?
//                                     <MultioptionButton buttons={saveButtons} buttonCallbacks={{
//                                         'save': () => saveClick(true),
//                                         'save-continue': () => saveClick(false),
//                                         'cancel': () => cancelEdition()
//                                     }}></MultioptionButton>
//                                     :
//                                     <i onClick={startEditing} className='icon-edit'></i>
//                                     */}

//                         </>
//                         }

//                     </div>
//                 </div>

//             }>
//                 {(true) &&
//                     <div className='history-item-content-component'>
//                         <div className='header-item-content'>
//                             {/* FIXME: confirm valid from label */}
//                             <BasicDatePicker
//                                 onChange={(newValue) => {
//                                     console.warn(newValue);
//                                     onChange({ name: "initialDate", value: newValue?.format("YYYY-MM-DD") || "" })
//                                 }}
//                                 maxDate={modifiedItem.finalDate}
//                                 value={modifiedItem.initialDate} disabled={!editing} label="Initial Date" />
//                             <BasicDatePicker
//                                 onChange={(newValue) => {
//                                     console.warn(newValue);
//                                     onChange({ name: "finalDate", value: newValue?.format("YYYY-MM-DD") || "" })
//                                 }}
//                                 minDate={modifiedItem.initialDate}
//                                 value={modifiedItem.finalDate} disabled={!editing} label="Valid Until" />
//                             <Radios disabled={!editing} onChange={(newV) => setModifiedItem(prev => ({ ...prev, costType: newV === 'true' ? "R" : "F" }))} value={isRangeBased} name="fixed" items={[{ value: true, label: "Range Based Cost" }, { value: false, label: "Fixed Cost" }]} />
//                         </div>
//                         <div className='content-item' onKeyUp={handleKeyDown}>
//                             <div className='headr'>
//                                 <div className='qty-header'>
//                                     <b>{isRangeBased ? "Quantity Range" : "Quantity"}</b>
//                                     {isRangeBased && editing && <button onClick={newRange} className='filled tiny'>
//                                         <i className='icon-add-new'></i>
//                                         <span>New Range  </span>
//                                     </button>}
//                                 </div>

//                                 <b>Unit Cost</b>
//                             </div>
//                             {isRangeBased ?
//                                 ranges.map((r, j) =>
//                                     <>
//                                         <div key={r.id} className='range-item'>
//                                             {editing ? <Input disableAutocomplete name="range" onChange={(e) => updateRange(j, e.target)} value={r.range} label="" /> : <span>{r.range}</span>}
//                                             <div className='unit-cost'>
//                                                 <span>$</span>
//                                                 {editing ? <Input disableAutocomplete name="unitCost" onChange={(e) => updateRange(j, e.target)} isNumeric value={r.unitCost} label="" /> : <span>{r.unitCost}</span>}
//                                                 <b>{currency?.prefix ?? ""}</b>
//                                                 {editing ?
//                                                     <>

//                                                         {
//                                                             (typeof (r.id) === "number") ?

//                                                                 <DialogTrigger
//                                                                     dialogContent={{
//                                                                         component: DeletePartDialog,
//                                                                         props: {
//                                                                             item: {},
//                                                                             message: `Are you sure you want to delete the range "${r.range}"?`,
//                                                                             onDelete: () => deleteRange(r.id)
//                                                                         }
//                                                                     }}
//                                                                 >
//                                                                     <i className='icon-delete-new'></i>
//                                                                 </DialogTrigger> :
//                                                                 <i className='icon-delete-new' onClick={() => discardRange(j)}></i>
//                                                         }
//                                                     </>

//                                                     : <div></div>}

//                                             </div>
//                                         </div>
//                                     </>

//                                 )
//                                 :
//                                 ranges?.length > 0 ? <div className='range-item'>
//                                     <span>1 Unit</span>
//                                     <i><i>

//                                         {/* {JSON.stringify(ranges[0])} */}
//                                     </i></i>
//                                     <div className='unit-cost'>
//                                         <span>$</span>
//                                         {editing ? <Input disableAutocomplete name="unitCost" onChange={(e) => updateRange(0, e.target)} isNumeric value={ranges[0].unitCost} label="" /> : <span>{ranges[0].unitCost ?? "--"}</span>}
//                                         <b>{currency?.prefix ?? ''}</b>
//                                     </div>
//                                 </div> : <div className='placeholder-component'>
//                                     <i></i>
//                                 </div>
//                             }
//                         </div>
//                     </div>}
//             </Expandable2>

//         </>
//     )
// }

function scrollToNextElement(container, direction) {
    if (!container || !(container instanceof HTMLElement)) {
        console.error("Invalid container element");
        return;
    }

    const scrollAmount = container.clientWidth; // Assuming full container width per step
    const currentScroll = container.scrollLeft;

    if (direction === "r") {
        container.scrollTo({
            left: currentScroll + scrollAmount,
            behavior: "smooth"
        });
    } else if (direction === "l") {
        container.scrollTo({
            left: currentScroll - scrollAmount,
            behavior: "smooth"
        });
    } else {
        console.error("Invalid direction. Use 'l' for left or 'r' for right.");
    }
}